<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container" :style="{height: contentHeight}">
        <div class="modal_header">
          <img :src="helpIcon" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <div
              class="help_list"
              v-for="(item, key) in helpItems"
              :key="item.index"
            >
              <div class="helpDate" v-text="item.date" />
              <div class="helpTitle" v-text="item.title" />
              <div class="helpText" v-text="item.text" />
              <hr v-if="key < helpItems.length - 1" />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="closeButton"
              class="cancel_button"
              @click="$emit('close')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    helpMsgs: Array
  },
  data() {
    return {
      helpIcon: require('../../img/help.png'),
      title: 'お知らせ',
      closeButton: '閉じる'
    }
  },
  computed: {
    helpItems() {
      var items = []
      for (let msg of this.helpMsgs) {
        var item = Object()
        item.title = msg.title
        item.text = msg.value
        var d = new Date(msg.updateDateTime)
        item.date =
          d.getFullYear() +
          '年' +
          (d.getMonth() + 1) +
          '月' +
          d.getDate() +
          '日 ' +
          d.toLocaleTimeString()
        items.push(item)
      }
      return items
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  height: 385px;
  width: 635px;
}
.modal_body {
  height: 337px;
}
.body {
  width: 100%;
  height: 229px;
  padding-top: 40px;
  overflow-y: scroll;
  /* IEでスクロールバーを隠す */
  -ms-overflow-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/showHelpModalWindow.vue